export default __webpack_public_path__ + "static/media/error.21ebd8b3.svg";